import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-valide-cmd-negoce',
  templateUrl: './valide-cmd-negoce.component.html',
  styleUrls: ['./valide-cmd-negoce.component.scss']
})
export class ValideCmdNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('ValideCmdNegoceComponent initialized');
        // Appliquer le filtrage initial pour le statut "Valide"
        this.dataService.filterOrdersByStatus('Valide');
    }

}
